import React from 'react'
// import profilePic from '../../../Assets/Images/profile.jpg'
import styles from '../Article/Article.module.css'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
const Articlepage = () => {
    const loggedInUser = useSelector(state => state.loggedInUser);
    return (
        <div className={styles.article}>
          
            <div className={`${styles.artice_page} ${styles.upperDirection}`}>
                <div className={styles.user}>
                    <img
                        src={loggedInUser.profile_pic}
                        alt="profile"
                        height="40"
                        width="40"
                    />
                    <h5 style={{fontWeight:"650", fontSize:"17px", color:"#2c2b2b"}}>{loggedInUser.name}</h5>
                </div>
                <div className={styles.tagone}>
                    <svg class="w-5 h-5 ml-2 fill-current" viewBox="0 0 640 512">
                        <path d="M625.941 293.823L421.823 497.941c-18.746 18.746-49.138 18.745-67.882 0l-1.775-1.775 22.627-22.627 1.775 1.775c6.253 6.253 16.384 6.243 22.627 0l204.118-204.118c6.238-6.239 6.238-16.389 0-22.627L391.431 36.686A15.895 15.895 0 00380.117 32h-19.549l-32-32h51.549a48 48 0 0133.941 14.059L625.94 225.941c18.746 18.745 18.746 49.137.001 67.882zM252.118 32H48c-8.822 0-16 7.178-16 16v204.118c0 4.274 1.664 8.292 4.686 11.314l211.882 211.882c6.253 6.253 16.384 6.243 22.627 0l204.118-204.118c6.238-6.239 6.238-16.389 0-22.627L263.431 36.686A15.895 15.895 0 00252.118 32m0-32a48 48 0 0133.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.746 18.746-49.138 18.745-67.882 0L14.059 286.059A48 48 0 010 252.118V48C0 21.49 21.49 0 48 0h204.118zM144 124c-11.028 0-20 8.972-20 20s8.972 20 20 20 20-8.972 20-20-8.972-20-20-20m0-28c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.49-48 48-48z"></path>
                    </svg>
                    <h5 className={styles.mytags}>My tags</h5>
                </div>
            </div>
            <Link className={styles.link} to="/create">
            <div className={`${styles.artice_page} ${styles.LowerDirection}`}>
                    <div className={styles.search}>
                        <div className={styles.borderone}>
                    <svg
                        class="w-6 h-6 mr-4 opacity-75 fill-current"
                        viewBox="0 0 512 512"
                    >
                        <path d="M493.255 56.236l-37.49-37.49c-24.993-24.993-65.515-24.994-90.51 0L12.838 371.162.151 485.346c-1.698 15.286 11.22 28.203 26.504 26.504l114.184-12.687 352.417-352.417c24.992-24.994 24.992-65.517-.001-90.51zM164.686 347.313c6.249 6.249 16.379 6.248 22.627 0L368 166.627l30.059 30.059L174 420.745V386h-48v-48H91.255l224.059-224.059L345.373 144 164.686 324.687c-6.249 6.248-6.249 16.378 0 22.626zm-38.539 121.285l-58.995 6.555-30.305-30.305 6.555-58.995L63.255 366H98v48h48v34.745l-19.853 19.853zm344.48-344.48l-49.941 49.941-82.745-82.745 49.941-49.941c12.505-12.505 32.748-12.507 45.255 0l37.49 37.49c12.506 12.506 12.507 32.747 0 45.255z"></path>
                    </svg>
                    </div>
                    <h5>Write an article...</h5>
                </div>
            </div>
                </Link>
        </div>
    )
}

export default Articlepage
